import {observer} from 'mobx-react';
import React from 'react';
import s from '../../s';
import {getAtcControlState} from './atc-control-state';

declare var _atc_color: boolean;

type Props = {
    label?: string;
    additionalClass?: string;
    clicked: () => Promise<void>;
};

const ATCButtonTemplate: React.FC<Props> = observer(({label: labelProp, additionalClass, clicked}) => {
    const label = labelProp || 'Add to cart';
    const control = getAtcControlState(s.ui.atc_busy, s.ui.ep_overflowing);

    return (
        <button
            className={`prod-atc-btn ${additionalClass || ''}${s.IsPortal3 ? ' portal3' : ''}${_atc_color ? ' atc_color' : ''}`}
            aria-label={label}
            onClick={clicked}
            disabled={control.disabled}
            aria-busy={control['aria-busy']}
            type="button"
        >
            {label}
            {s.ui.atc_busy && (
                <span
                    className="pad-left"
                    aria-hidden="true"
                >
                    <i className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"></i>
                </span>
            )}
        </button>
    );
});

export default ATCButtonTemplate;
